import {useState, useRef, useEffect} from 'react'
import {useSearchParams} from 'react-router-dom'

import Style from './style'

import Search from 'widget/Search'
import Pagenation from 'widget/Pagenation'

import DefaultModal from 'shared/ui/DefaultModal'
import DefaultButton from 'shared/ui/DefaultButton'
import TStyle from 'shared/style/tableStyle'

import useGetAccountList from 'entity/account/useGetAccountList'
import useGetSeedTicketTypeList from 'entity/series/useGetSeedTicketTypeList'
import usePostSeedTicketTypeGive from 'entity/account/usePostAccountSeedTicketGive'

import {convertProGradeAsName} from 'shared/constant/lookup/proGrade'
import SortableHeader from 'shared/ui/SortableHeader'
import TableLoading from 'shared/ui/TableLoading'
import useRoleCookie from 'shared/model/useRoleCookie'
import {ROLE_COMPETITION_MANAGER} from 'shared/constant/lookup/role'

const GiveModal = ({seriesIdx, closeEvent}) => {
	const [searchParams] = useSearchParams()
	const page = searchParams.get('page')
	const search = searchParams.get('search')
	const [userRole] = useRoleCookie()

	const seedTicketTypeIdxRef = useRef()
	const [accountIdx, setAccountIdx] = useState()
	const numberRef = useRef()

	const [accountList, isLoading] = useGetAccountList({
		enableSearchGlobally: true,
	})
	const [seedTicketTypeList] = useGetSeedTicketTypeList(seriesIdx)
	const [giveTicket] = usePostSeedTicketTypeGive(
		seedTicketTypeIdxRef,
		accountIdx,
		numberRef
	)

	const sizeList = ['short', 'short', 'medium', 'expand', 'medium', 'medium']
	const tableHeadList = [
		{label: '선택'},
		{label: 'IDX', sortKey: 'idx'},
		{label: '이름', sortKey: 'name'},
		{label: '닉네임', sortKey: 'nickname'},
		{label: '연락처', sortKey: 'contact'},
		{label: '프로 자격', sortKey: 'pro_grade_flag'},
	]
	const tableDataList = accountList?.data?.account_list

	// 시드권 선택 이벤트
	const changeSelectEvent = (e) => {
		seedTicketTypeIdxRef.current = e.target.value
	}

	const changeCheckboxEvent = (idx) => {
		if (accountIdx !== idx) setAccountIdx(idx)
		else setAccountIdx(null)
	}

	useEffect(() => {
		setAccountIdx(null)
	}, [page, search])

	return (
		<DefaultModal title={'시드권 지급'} closeEvent={closeEvent}>
			<Style.Wrapper>
				<Search
					placeholder='IDX, 이름, 닉네임, 연락처로 검색'
					qualificationFilter={userRole !== ROLE_COMPETITION_MANAGER}
					statusFilter={userRole !== ROLE_COMPETITION_MANAGER}
					searchGroup='account'
				/>

				<TableLoading isLoading={isLoading}>
					<TStyle.TableDiv>
						<TStyle.TableInner>
							<TStyle.TableRow $title>
								{tableHeadList.map((elem, index) => (
									<TStyle.Data key={index} $title $size={sizeList[index]}>
										<SortableHeader sortKey={elem.sortKey}>
											{elem.label}
										</SortableHeader>
									</TStyle.Data>
								))}
							</TStyle.TableRow>
							{tableDataList?.map((elem, index) => (
								<TStyle.TableRow
									key={index}
									$odd={index % 2 === 1}
									onClick={() => changeCheckboxEvent(elem?.idx)}
								>
									<TStyle.Data $size={sizeList[0]}>
										<input type='checkbox' checked={accountIdx === elem?.idx} />
									</TStyle.Data>
									<TStyle.Data $size={sizeList[1]}>{elem?.idx}</TStyle.Data>
									<TStyle.Data $size={sizeList[2]}>{elem?.name}</TStyle.Data>
									<TStyle.Data $size={sizeList[3]}>
										{elem?.nickname}
									</TStyle.Data>
									<TStyle.Data $size={sizeList[4]}>{elem?.contact}</TStyle.Data>
									<TStyle.Data $size={sizeList[5]}>
										{convertProGradeAsName[elem?.pro_grade_flag]}
									</TStyle.Data>
								</TStyle.TableRow>
							))}
						</TStyle.TableInner>
					</TStyle.TableDiv>
				</TableLoading>

				<Pagenation maxPage={accountList?.data?.max_page} />

				<Style.GiveDiv>
					<select onChange={changeSelectEvent}>
						<option>== 시드권 종류 ==</option>
						{seedTicketTypeList?.data?.seed_ticket_type?.map((elem) => (
							<option value={elem?.idx}>{elem?.name}</option>
						))}
					</select>
					<input placeholder='개수 입력' ref={numberRef} />
					<DefaultButton small fitWidth expandHeight clickEvent={giveTicket}>
						지급
					</DefaultButton>
				</Style.GiveDiv>
			</Style.Wrapper>
		</DefaultModal>
	)
}

export default GiveModal
